export const chainReducers = (...args) => (state, action) =>
  args.reduce((prev, f) => f(prev, action), state);
